@for (vacature of vacatures(); track vacature.vacatureId) {
  <div class="c-slat u-mb1">
    <mvw-vacature-detail [vacature]="vacature"></mvw-vacature-detail>
  </div>
}